import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { BoxFlex } from '@woovi/ui';

import type { ReactNode } from 'react';

type PaymentSectionProps = {
  children: string;
};

const PaymentSectionChip = ({ children }: PaymentSectionProps): ReactNode => {
  const theme = useTheme();

  return (
    <BoxFlex
      sx={{
        position: 'absolute',
        py: 0.5,
        px: 2,
        top: -15,
        left: 20,
        backgroundColor: theme.palette.grey[300],
        borderRadius: theme.shape.borderRadius,
        userSelect: 'none',
      }}
    >
      <Typography sx={{ fontWeight: theme.typography.fontWeightBold }}>
        {children}
      </Typography>
    </BoxFlex>
  );
};

export default PaymentSectionChip;
